class QuickStartModuleTask implements Interfaces.IQuickStartModuleCounter {
    QuickStartModuleCounterMessageBusEventName: string = "notifyUserOnTaskChange";
    QuickStartModuleCounterGetValueUrl: string = "TaskBook/GetTaskCountByUserId";
}
export default QuickStartModuleTask;